// extracted by mini-css-extract-plugin
export default {"styles":"ProgramCard_styles__zNojA"};